import { render, staticRenderFns } from "./VisitCalendarViewMode.vue?vue&type=template&id=c80c822a&scoped=true"
import script from "./VisitCalendarViewMode.vue?vue&type=script&lang=js"
export * from "./VisitCalendarViewMode.vue?vue&type=script&lang=js"
import style0 from "./VisitCalendarViewMode.vue?vue&type=style&index=0&id=c80c822a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80c822a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80c822a')) {
      api.createRecord('c80c822a', component.options)
    } else {
      api.reload('c80c822a', component.options)
    }
    module.hot.accept("./VisitCalendarViewMode.vue?vue&type=template&id=c80c822a&scoped=true", function () {
      api.rerender('c80c822a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/visit-registration-calendar/components/VisitCalendarViewMode.vue"
export default component.exports